import { call, put, takeLatest } from "redux-saga/effects";
import conxtdOut from "apis/conxtdOut";

import {
  loadCompanyFieldsSuccess,
  loadCompanyFieldsFailed,
  loadEnterpriseFieldsSuccess,
  loadEnterpriseFieldsFailed,
  loadEnterpriseGroupsSuccess,
  loadEnterpriseGroupsFailed,
  loadEnterpriseAssociationsSuccess,
  loadEnterpriseAssociationsFailed,
  loadCompanyAssetsSuccess,
  loadCompanyAssetsFailed,
  loadSiteAssetsSuccess,
  loadSiteAssetsFailed,
  loadCompanyAssetLogsSuccess,
  loadCompanyAssetLogsFailed,
  loadCompanyAssetLogViewSuccess,
  loadCompanyAssetLogViewFailed,
  loadCompanyAssociatedEnterprisesSuccess,
  loadCompanyAssociatedEnterprisesFailed,
  loadCompanyUnassociatedEnterprisesSuccess,
  loadCompanyUnassociatedEnterprisesFailed,
  loadCompanyDeletedEnterprisesSuccess,
  loadCompanyDeletedEnterprisesFailed,
  loadCompanyCreateEnterpriseSuccess,
  loadCompanyCreateEnterpriseFailed,
} from "services/redux/actions/serviceDesk";

// Add Site - get company custom fields
// https://mars.conxtd.com/out_api/ServiceDesk/getCompanyCustomFields
function* loadCompanyFieldsRe(action) {
  try {
    
    const { companyId } = action.payload;
    const url = `/ServiceDesk/getCompanyCustomFields/${companyId}`;

    const response = yield call(conxtdOut.get, url);

    yield put(loadCompanyFieldsSuccess(response));
  } catch (e) {
    yield put(loadCompanyFieldsFailed(e.message));
  }
}

export function* watchLoadCompanyFields() {
  yield takeLatest("LOAD_FORM_DATA_START", loadCompanyFieldsRe);
}

// Add Site - get enterprise custom fields
// https://mars.conxtd.com/out_api/ServiceDesk/getCompanyCustomFields
function* loadEnterpriseFieldsRe(action) {
  try {
    
    const { enterprise } = action.payload;
    const url = `/ServiceDesk/getEnterpriseCustomFields/${enterprise}`;

    const response = yield call(conxtdOut.get, url);

    yield put(loadEnterpriseFieldsSuccess(response));
  } catch (e) {
    yield put(loadEnterpriseFieldsFailed(e.message));
  }
}

export function* watchLoadEnterpriseFields() {
  yield takeLatest("LOAD_ENTERPRISE_FIELDS_START", loadEnterpriseFieldsRe);
}

// Add Site - get enterprise custom fields
// https://mars.conxtd.com/out_api/ServiceDesk/getGroups
function* loadEnterpriseGroupsRe(action) {
  try {
    
    const { enterprise } = action.payload;
    const url = `/ServiceDesk/getGroups/${enterprise}`;

    const response = yield call(conxtdOut.get, url);

    yield put(loadEnterpriseGroupsSuccess(response));
  } catch (e) {
    yield put(loadEnterpriseGroupsFailed(e.message));
  }
}

export function* watchLoadEnterpriseGroups() {
  yield takeLatest("LOAD_ENTERPRISE_GROUPS_START", loadEnterpriseGroupsRe);
}


// -- ASSET EDITOR --

// get sudo site id
// https://mars.conxtd.com/out_api/ServiceDesk/getSudoSiteId
// function* loadSudoSiteIdRe(action) {
//   try {
    
//     const { sudoSiteRef, companyId } = action.payload;
//     const url = `/ServiceDesk/getSudoSiteId/${sudoSiteRef}/${companyId}`;

//     const response = yield call(conxtdOut.get, url);

//     // Dispatch success action with the response
//     yield put(loadSudoSiteIdSuccess(response));
//   } catch (e) {
//     // Dispatch failed action with the error
//     yield put(loadSudoSiteIdFailed(e.message));
//   }
// }

// export function* watchLoadSudoSiteId() {
//   yield takeLatest("LOAD_SUDO_SITE_ID_START", loadSudoSiteIdRe);
// }

// get sudo site id
// https://mars.conxtd.com/out_api/ServiceDesk/getEnterpriseAssociations
function* loadEnterpriseAssociationsRe(action) {
  try {
    
    const { sudoSiteId } = action.payload;
    const url = `/ServiceDesk/getEnterpriseAssociations/${sudoSiteId}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadEnterpriseAssociationsSuccess(response));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadEnterpriseAssociationsFailed(e.message));
  }
}

export function* watchLoadEnterpriseAssociations() {
  yield takeLatest("LOAD_ENTERPRISE_ASSOCIATIONS_START", loadEnterpriseAssociationsRe);
}

// get company assets
// https://mars.conxtd.com/out_api/company-assets/view
function* loadCompanyAssetsRe(action) {
  try {

    const { companyId } = action;

    const limit = action.pageSize || 100;
    const page = action.requestPageNumber || 1;

    // const sort = action.sortField || "";
    // const direction = action.sortDirection || "";

    const filterSearchParams = Object.fromEntries(
      (action.filters || []).map(f => [f.id, f.value])
  );


    const params = new URLSearchParams({
      limit: limit,
      page: page,
      // sort: sort,
      // direction: direction,
      ...filterSearchParams ?? "",
    });

    const filterData = {
      filterQueryString: params.toString(),
      filtersActive: Object.values(filterSearchParams).length > 0,
    }

    // const displayPageIndex = yield select(getCompanyDisplayPageIndex);

    const url = `/company-assets/index/${companyId}/?${params.toString()}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadCompanyAssetsSuccess(response, filterData));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadCompanyAssetsFailed(e.message));
  }
}

export function* watchLoadCompanyAssets() {
  yield takeLatest("LOAD_COMPANY_ASSETS_START", loadCompanyAssetsRe);
}

// get site assets
// https://mars.conxtd.com/out_api/company-assets/view
function* loadSiteAssetsRe(action) {
  try {
    
    const { assetId, sudoSiteId } = action;

    const limit = action.pageSize || 20;
    const page = action.requestPageNumber || 1;

    // const sort = action.sortField || "";
    // const direction = action.sortDirection || "";

    let filterSearchParams = [];
    if (action.filters && action.filters.length > 0) {
      action.filters.forEach(filter => {
        filterSearchParams[filter.id] = filter.value;
      });
    }

    const params = new URLSearchParams({
      limit: limit,
      page: page,
      // sort: sort,
      // direction: direction,
      ...filterSearchParams,
    });

    const url = `/company-assets/view/${assetId}/${sudoSiteId}/?${params.toString()}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadSiteAssetsSuccess(response));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadSiteAssetsFailed(e.message));
  }
}

export function* watchLoadSiteAssets() {
  yield takeLatest("LOAD_SITE_ASSETS_START", loadSiteAssetsRe);
}

function* loadCompanyAssetLogsRe(action) {
  try {

    // const { companyId } = action;

    const limit = action.pageSize || 20;
    const page = action.requestPageNumber || 1;

    const sort = action.sortField || "";
    const direction = action.sortDirection || "";

    const filterSearchParams = Object.fromEntries(
      (action.filters || []).map(f => [f.id, f.value])
    );

    const params = new URLSearchParams({
      limit: limit,
      page: page,
      // sort: sort,
      // direction: direction,
      ...filterSearchParams ?? "",
    });

    // const filterData = {
    //   filterQueryString: params.toString(),
    //   filtersActive: Object.values(filterSearchParams).length > 0,
    // }

    // const displayPageIndex = yield select(getCompanyDisplayPageIndex);

    const url = `/company-assets-bulk/import-logs-index?${params.toString()}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadCompanyAssetLogsSuccess(response));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadCompanyAssetLogsFailed(e.message));
  }
}

export function* watchLoadCompanyAssetLogs() {
  yield takeLatest("LOAD_COMPANY_ASSET_LOGS_START", loadCompanyAssetLogsRe);
}

function* loadCompanyAssetLogViewRe(action) {
  try {

    const { uid } = action;

    const limit = action.pageSize || 10;
    const page = action.requestPageNumber || 1;
    const perPage = action.pageSize || 10;

    // const sort = action.sortField || "";
    // const direction = action.sortDirection || "";

    const filterSearchParams = Object.fromEntries(
      (action.filters || []).map(f => [f.id, f.value])
    );

    const params = new URLSearchParams({
      limit: limit,
      page: page,
      perPage: limit,
      pageSize: limit,
      ...filterSearchParams ?? "",
    });

    const url = `/company-assets-bulk/import-logs-view/${uid}?${params.toString()}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadCompanyAssetLogViewSuccess(response));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadCompanyAssetLogViewFailed(e.message));
  }
}

export function* watchLoadCompanyAssetLogView() {
  yield takeLatest("LOAD_COMPANY_ASSET_LOG_VIEW_START", loadCompanyAssetLogViewRe);
}

function* loadCompanyAssociatedEnterprises(action) {
  try {

    const { companyId } = action;

    const defLimit = action.pageSize || 5;
    const defPage = action.requestPageNumber || 1;

    // const sort = action.sortField || "";
    // const direction = action.sortDirection || "";

    const filterSearchParams = Object.fromEntries(
      (action.filters || action?.filtered || []).map(f => [f.id, f.value])
    );

    const params = new URLSearchParams({
      limit: action.pageSize || defLimit,
      page: action.requestPageNumber || defPage,
      perPage: action.pageSize || defLimit,
      pageSize: action.pageSize || defLimit,
      ...filterSearchParams ?? "",
    });

    const url = `/ServiceDesk/viewAssociatedEnterprises/${companyId}?${params.toString()}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadCompanyAssociatedEnterprisesSuccess(response));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadCompanyAssociatedEnterprisesFailed(e.message));
  }
}

export function* watchLoadCompanyAssociatedEnterprises() {
  yield takeLatest("LOAD_COMPANY_ASSOCIATED_ENTERPRISES_START", loadCompanyAssociatedEnterprises);
}

function* loadCompanyUnassociatedEnterprises(action) {
  try {

    const { companyId, paramsObj } = action;

    const defLimit = action.pageSize || 5;
    const defPage = action.requestPageNumber || 1;

    // const sort = action.sortField || "";
    // const direction = action.sortDirection || "";

    const filterSearchParams = Object.fromEntries(
      (action.filters || []).map(f => [f.id, f.value])
    );

    const { limit: argLimit, page: argPage, filters: argFilters } = paramsObj || {};

    const params = new URLSearchParams({
      limit: argLimit ?? defLimit,
      page: argPage ?? defPage,
      perPage: argLimit ?? defLimit,
      pageSize: argLimit ?? defLimit,
      ...filterSearchParams ?? "",
    });

    const url = `/ServiceDesk/viewUnassociatedEnterprises/${companyId}?${params.toString()}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadCompanyUnassociatedEnterprisesSuccess(response));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadCompanyUnassociatedEnterprisesFailed(e.message));
  }
}

export function* watchLoadCompanyUnassociatedEnterprises() {
  yield takeLatest("LOAD_COMPANY_UNASSOCIATED_ENTERPRISES_START", loadCompanyUnassociatedEnterprises);
}

function* loadCompanyDeletedEnterprises(action) {
  try {

    const { companyId } = action;

    const defLimit = action.pageSize || 5;
    const defPage = action.requestPageNumber || 1;
    // const sort = action.sortField || "";
    // const direction = action.sortDirection || "";
    
    const filterSearchParams = Object.fromEntries(
      (action?.filters || action?.filtered || []).map(f => [f.id, f.value])
    );

    const params = new URLSearchParams({
      limit: action.pageSize || defLimit,
      page: action.requestPageNumber || defPage,
      perPage: action.pageSize || defLimit,
      pageSize: action.pageSize || defLimit,
      ...filterSearchParams ?? "",
    });

    const url = `/ServiceDesk/viewDeletedEnterprises/${companyId}?${params.toString()}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadCompanyDeletedEnterprisesSuccess(response));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadCompanyDeletedEnterprisesFailed(e.message));
  }
}

export function* watchLoadCompanyDeletedEnterprises() {
  yield takeLatest("LOAD_COMPANY_DELETED_ENTERPRISES_START", loadCompanyDeletedEnterprises);
}


export function* loadCompanyCreateEnterprise(action) {
  try {
    const { company_id } = action;

    const limit = action.pageSize || 20;
    const page = action.requestPageNumber || 1;

    if (!company_id) 
      throw new Error(
        "company_id is required for loading company"
      );

    let paramString = "";
    action.filters && action.filters.forEach((filter) => {
      paramString = `${paramString}&${filter.id}=${filter.value}`
    });
    action.externalFilters && action.externalFilters.forEach((externalFilter) => {
      paramString = `${paramString}&${externalFilter.id}=${externalFilter.value}`
    });

    const url = `/Authake/getSites/${company_id}?limit=${limit}&page=${page}${paramString}`;

    const response = yield call(conxtdOut.get, url);

    // Dispatch success action with the response
    yield put(loadCompanyCreateEnterpriseSuccess(response));
  } catch (e) {
    // Dispatch failed action with the error
    console.log(e.message)
    yield put(loadCompanyCreateEnterpriseFailed(e.message));
  }
}

export function* watchLoadCompanyCreateEnterprise() {
  yield takeLatest("LOAD_COMPANY_CREATE_ENTERPRISE_START", loadCompanyCreateEnterprise);
}